import "./Button.css";

export default function Button({ className = "", ...props }) {
  return <button className={`Button-glass ${className}`} {...props} />
}
